import * as React from 'react';
import { usePreference } from 'ra-core';
import { Box, Checkbox, FormControlLabel, List, ListItem, ListItemText } from '@mui/material';

export const CustomFieldsSelector = ({ availableColumns, columns: initialColumns, omit }) => {
    const [columns, setColumns] = usePreference('columns', initialColumns);

    const handleToggle = React.useCallback(
        index => {
            const newColumns = columns.includes(index) ? columns.filter(i => i !== index) : [...columns, index];
            setColumns(newColumns);
        },
        [columns, setColumns],
    );

    return (
        <List>
            {availableColumns.map(column => (
                <ListItem key={column.index} disablePadding sx={{ display: 'block' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={columns.includes(column.index)}
                                onChange={() => handleToggle(column.index)}
                                disabled={omit?.includes(column.source)}
                            />
                        }
                        label={
                            <Box>
                                <ListItemText primary={column.label || column.source} />
                            </Box>
                        }
                    />
                </ListItem>
            ))}
        </List>
    );
};
